/** Route helpers. The editorial site is the root now; auth/dashboard share it. */
export const route = (lang: string, sub = ""): string =>
  `/${lang}${sub ? `/${sub}` : ""}`;

export const isLanding = (pathname: string, lang: string): boolean =>
  pathname.replace(/\/$/, "") === route(lang);
